import React from 'react';
import { connect } from "react-redux";
import PowerbiEmbedded from "react-powerbi";
import {
    fetchReports
} from '../../../../store/actions/reportsAction'

class Eligibility extends React.Component{
    constructor(props){
        super(props);
        console.log("eligibility index", this.props.user);
        this.props.fetchReports('aeafbb4a-5ce0-45be-bb52-f7410441d1df');
        this.state = {
            reportID: 'aeafbb4a-5ce0-45be-bb52-f7410441d1df',
            user: this.props.user,
            token: {}
        }
        const {user, reportID} = this.state;
        user && this.props.fetchReports({reportID, user});
    }

    componentWillReceiveProps(nextProps, prevProps){
        if(nextProps.token){
            if(nextProps.token !== this.state.token){
                this.setState({
                    token: nextProps.token,
                    user: nextProps.user
                });
                
            }
        }
    }
    render() {
        const { token, user } = this.state;
        const { reportID } = this.state;
        console.log("eligibility index", this.props.user);
        return (
            <div style={{width: '100%', height: 'calc( 100vh - 60px )'}}>
                {token && <PowerbiEmbedded
                    id={`${reportID}`}
                    userId={ user.userId }
                    embedUrl={token.embedUrl}
                    accessToken={token.accessToken}
                    filterPaneEnabled={true}
                    navContentPaneEnabled={true}
                    tokenType='Embed'
                    width="100%"
                    height="100%"
                    onEmbedded={this.onEmbedded}
                />}
            </div>
        )
    }
}

const mapStateToProps = state => ({
    token: state.token.token,
    user: state.auth.user

})

export default connect(mapStateToProps, {
    fetchReports
})(Eligibility);